import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { paymentsFetch } from "./paymentsFetch";

const RemoveBooingPayment = async (paymentId: string) => {
  return paymentsFetch(`/api/payments/${paymentId}`, "DELETE");
};

export const useRemoveBookingPaymentMutation = (paymentId: string, bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { toastId: any }) => {
      return RemoveBooingPayment(paymentId);
    },
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Payment removed successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["paymentsData", bookingId] });
      queryClient.invalidateQueries({ queryKey: ["paymentScheduleCustomerData", bookingId] });
      queryClient.invalidateQueries({ queryKey: ["paymentScheduleOperatorData", bookingId] });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to remove booking payment!",
        variant: "destructive",
      });
    },
  });
};
